import {Injectable} from '@angular/core'

import * as firebase from 'firebase/app';

import {Jsonp} from '@angular/http';

import { AngularFireDatabase, AngularFireObject } from 'angularfire2/database';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { AngularFireStorage } from 'angularfire2/storage';

import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';

import Coverage from '../models/coverage.model'
import CoverageC from '../models/coveragec.model'
import Post from '../models/post.model'
import Widget from '../models/widget.model'

import Card from '../models/card.model';


export interface Item { id: string; name: string; }

//import Data from '../models/data.model'

import { Storage } from '@ionic/storage';
//import {LocalStorageService} from 'ngx-webstorage';

import { Response } from '@angular/http';
//import * as ipdata from 'ipdata';

//import * as firebase from 'firebase/app';



import {SnotifyService} from 'ng-snotify';

import {TranslateService, LangChangeEvent} from '@ngx-translate/core';

export var single = [
  {
    "name": "Germany",
    "value": 8940000
  },
  {
    "name": "Notes",
    "value": 5000000
  },
  {
    "name": "France",
    "value": 7200000
  },
  {
    "name": "kk",
    "value": 7200000
  }
];

export var multi = [
  {
    "name": "Germany",
    "series": [
      {
        "name": "2010",
        "value": 7300000
      },
      {
        "name": "2011",
        "value": 8940000
      }
    ]
  },

  {
    "name": "USA",
    "series": [
      {
        "name": "2010",
        "value": 7870000
      },
      {
        "name": "2011",
        "value": 8270000
      }
    ]
  },

  {
    "name": "France",
    "series": [
      {
        "name": "2010",
        "value": 5000002
      },
      {
        "name": "2011",
        "value": 5800000
      },
      {
        "name": "France",
        "value": 7200000
      },
      {
        "name": "kk",
        "value": 7200000
      }
    ]
  }
];

//ReplaySubject 
@Injectable()
export class CoverageService {
  //currentCoverage: Subject<Coverage> = new BehaviorSubject<Coverage>(null)
  item: any;
  store

  private coverageCollection: AngularFirestoreCollection<CoverageC>;
  private coverageDoc: AngularFirestoreDocument<CoverageC>;
  private feedCollection: AngularFirestoreCollection<Item>;
  private cardCollectionRef: AngularFirestoreCollection<Card>;
  private cardDocumentRef: AngularFirestoreDocument<Card>;

  // storage
  date

  like
  lang2

  items

  userId = '3c67b57fa85a25f8d8f502072';
  //listId = '6f13ecb8a8'; // 995165ebb6
  listId = 'b7063f4118'; //'6f13ecb8a8';

  mailChimpUrl = 'https://e-eclectic.us8.list-manage.com/subscribe/post-json';

  cdm


  private cat = new Subject<any>();
  private basket = new Subject<any>();
  public lang = new Subject<any>();
  public currency = new Subject<any>();

  public color = new Subject<any>();
  public upload_list = new Subject<any>();
  
  
  //lang

  constructor(
    public af: AngularFireDatabase, 
    private afs: AngularFirestore,
    public translateService: TranslateService,
    public storage: Storage,
    public jsonp: Jsonp,
    private snotifyService: SnotifyService,
    private firestorage: AngularFireStorage
  ) {
    //this.rootRef = firebaseService.rootRef

    //this.storage = localStorage
    //this.like = []

    //this.lang2 = translateService.currentLang
    //this.init(false);
    var date2 = new Date();
    this.date = date2.getTime();

  }

  /*function dataURIToBlob(dataURI, callback) {
    var binStr = atob(dataURI.split(',')[1]),
      len = binStr.length,
      arr = new Uint8Array(len);
  
    for (var i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
  
    callback(new Blob([arr]));
  }
  
  var callback = function(blob) {
      var a = document.createElement('a');
      a.download = fileName;
      a.innerHTML = 'download';
      // the string representation of the object URL will be small enough to workaround the browser's limitations
      a.href = URL.createObjectURL(blob);
      // you must revoke the object URL, 
      //   but since we can't know when the download occured, we have to attach it on the click handler..
      a.onclick = function() {
        // ..and to wait a frame
        requestAnimationFrame(function() {
            URL.revokeObjectURL(a.href);
          });
          a.removeAttribute('href')
        };
      };
  
  dataURIToBlob(yourDataURL, callback);*/

  sendUpload(data) {
    //console.log('sendBasket', data)
    this.upload_list.next(data);
  }

  clearUpload() {
      this.upload_list.next({});
  }

  getUpload(): Observable<any> {
      return this.upload_list.asObservable();
  }

  sendMailOk(email) {


    let msg = this.translateService.instant('FORM_MAIL_SEND');

    this.snotifyService.success(msg, 'Message', {
      timeout: 5000,
      showProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      titleMaxLength: 100,
      bodyMaxLength:1000,
    });

  }

  sendBasketOk(email) {


    let msg = this.translateService.instant('FORM_MAIL_SEND');

    this.snotifyService.success(msg, 'Message', {
      timeout: 5000,
      showProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      titleMaxLength: 100,
      bodyMaxLength:1000,
    });

  }

  uploadFile3(file, name) {
    // const file = event.target.files[0];


    // if (Extension == "gif" || Extension == "png" || Extension == "bmp" || Extension == "jpeg" || Extension == "jpg")
    // const filePath = 'selfie';
    // console.log(filename);
    // const filename = 'test.png';
    


    return new Promise((resolve, reject) => {

      // let storageRef = firebase.storage().ref();
      const extension = name.substring(name.lastIndexOf('.') + 1).toLowerCase();
      const filename = Math.floor(Date.now() / 1000) + '.' + extension;
      // const imageRef = storageRef.child(`images/${filename}.png`);

      //this.upload_list.push({name: name, perc: 0, url:false});
		  this.sendUpload({name: name, perc: 0, url: false});
      
      

      this.firestorage.upload('upload/' + filename, file).then((snapshot)=> {

          // il codice sotto prende l'url della foto appena caricata
          // this.getImg('base', filename).subscribe((url) => {
            // alert(url); 
            let uploadCollection = this.afs.collection<any>('upload');
      
            // uploadCollection.ref.set({url}, { merge: true });
            uploadCollection.ref.add({img: 'upload/' + filename});

            resolve(filename);
        
          // });
          // this.showSuccesfulUploadAlert();


        }, (err) => { });
    });

    // observe percentage changes
    // this.uploadPercent = task.percentageChanges();
    // get notified when the download URL is available
    // this.downloadURL = task.downloadURL();
  }

  uploadFile(file) {
    return new Promise((resolve, reject) => {

      // let storageRef = firebase.storage().ref();
      const filename = Math.floor(Date.now() / 1000);
      // const imageRef = storageRef.child(`images/${filename}.png`);

      let storagefirebase = this.firestorage.ref('selfies').child(`${filename}.png`)

      storagefirebase.putString(file, firebase.storage.StringFormat.DATA_URL).then((snapshot)=> {

  // il codice sotto prende l'url della foto appena caricata
          this.getImg('selfies', `${filename}.png`).subscribe((url) => {
            // alert(url);
            let uploadCollection = this.afs.collection<any>('upload');
            // uploadCollection.ref.set({url}, { merge: true });
            // uploadCollection.ref.add({img: 'selfies/' + filename + '.png'});
            uploadCollection.ref.add({url: url, img: 'selfies/' + filename + '.png'});

            // resolve('selfies/' + filename + '.png')
            resolve(url)

          });
          // t his.showSuccesfulUploadAlert();


        }, (err) => { });
    });

  }

  getImg(ref, img) {
      return this.firestorage.ref(ref).child(img).getDownloadURL();
  }

  getDataUp(ref, img) {
    return this.firestorage.ref(ref).child(img).getDownloadURL();
  }

  init(config){
    
      const firebaseConfig = {
        apiKey: "AIzaSyBx0l-pemEWekTp0xGUBO1dlrQDbLKs0JU",
        authDomain: "cdm-2018-f941f.firebaseapp.com",
        databaseURL: "https://cdm-2018-f941f.firebaseio.com",
        projectId: "cdm-2018-f941f",
        storageBucket: "cdm-2018-f941f.appspot.com",
        messagingSenderId: "832080279207"
      };
    

      const cdm = firebase.initializeApp(firebaseConfig,"cdm");
      this.cdm = cdm.database().ref('');

      this.store = cdm.storage()
      //const listObs = this.af.database.object(ref);
      //listObs.subscribe(data => console.log(data));
  }


  get_info_cookie() {
    return new Promise((resolve, reject) => {

      this.storage.get('info').then((data) => {
        
        if(!data) {

          resolve('O')
  
        } else {

          resolve(data)
  
        }
      
        //this.translateService.use(lang);
      
      }).catch( (e) => {
        resolve('O')
        //this.data.showLoginClose = (UserService.getUser() || !this.isCordova.f() );
      });

    });
  }

  set_info (id) {
    if(id == 0)  this.storage.remove('info');    
    else this.storage.set('info', id);    
  }    

  get_info (id) {

    console.log(id)

    var data = {}

    //if(id==1) 
    data = {name: 'éclectic', slug: 'eclectic', logo: '/assets/img/logo_eclectic.png', menu: '1', social: {facebook: 'eclectic8ruecharlot', instagram: 'eclectic_official'}}
    if(id==2) data = {name: 'aware', slug: 'aware', logo: '/assets/img/awareAnim.svg', logo2: '/assets/img/logo_aware.png', menu: '2', social: {facebook: '', instagram: ''}}
    else if(id==3) data = {name: 'CDM', slug: 'aware', logo: '/assets/img/logo_aware.png', menu: '3', social: {facebook: '', instagram: ''}}
    //if(id===2) data = {name: 'aware', logo: 'http://e-eclectic.com/app/admin/wp-content/uploads/sites/6/2017/05/LOGO_OK-03.png', menu: '2'}
    //data.logo = 'basket';

    return data;
    //let ref = this.af.list('/form-basket/');
    //ref.push(data);
  }
  
  send_mail (data) {
    
    let ref = this.af.list('/form-send/');
    ref.push(data);
  }

  send_basket (data, basket, sendTo) {
    data.sendTo = sendTo
    data.basket = basket
    let ref = this.af.list('/form-basket/');
    ref.push(data);
  }

  sendCat(data) {
      this.cat.next(data);
  }

  clearCat() {
      this.cat.next({});
  }

  getCat(): Observable<any> {
      return this.cat.asObservable();
  }




  sendColor(data) {
    this.color.next(data);
}

  clearColor() {
      this.color.next({});
  }

  getColor(): Observable<any> {
      return this.color.asObservable();
  }



  initLang() {

    return new Promise((resolve, reject) => {
        
      
      var lang
      this.storage.get('lang').then((data) => {
        console.log('storage lang', data)

    
        if(!data) {

          /*if (this.translate.getBrowserLang() !== undefined) {
            this.translate.use(this.translate.getBrowserLang());
          } else {
            this.translate.use('en'); // Set your language here
          }*/

          var userLang = navigator.language.split('-')[0]; // use navigator lang if available
          userLang = /(fr|en)/gi.test(userLang) ? userLang : 'ang';

          if(userLang==='en') userLang = 'ang';
          console.log('lang nav', userLang);

          lang = userLang;

          this.translateService.use(lang);
          this.setLang(lang);

        } else {
          //this.lang = data
          lang = data
          //this.categories = MenuService.getAll2();
        }
      
        this.translateService.use(lang);
        this.setLang(lang);
        resolve(lang)
        

      /*this.translate.get(['COOKIE_MSG_TEXT', 'COOKIE_MSG_TITLE']).subscribe(values => {
        this.cookieText = values.COOKIE_MSG_TEXT;
        this.cookieText2 = values.COOKIE_MSG_TITLE;
        console.log(this.cookieText2)
      });*/
        //console.log(lang)

      }).catch( (e) => {

        var userLang = navigator.language.split('-')[0]; // use navigator lang if available
        userLang = /(fr|en)/gi.test(userLang) ? userLang : 'ang';

        if(userLang==='en') userLang = 'ang';
        console.log('lang nav', userLang);

        lang = userLang;

        this.translateService.use(lang);
        this.setLang(lang);

        //this.data.showLoginClose = (UserService.getUser() || !this.isCordova.f() );
    });


    });
  }

  checkLang() {
    

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      console.log(event.lang,'event.lang')
      //this.translateService.use(event.lang);
      //this.lang = event.lang;
    
      /*if(this.lang==='fr') this.categories = this.MenuService.getAll();
      else this.categories = this.MenuService.getAll2();

      this.coverageService.get_info_cookie().then(data => { 
        if(data != 0) 
          {
            this.site = this.coverageService.get_info(data); 
            //this.site = this.coverageService.get_info(2);  //if(this.site.menu === 2) 
            if(data == 1) this.categories = this.MenuService.getAll();
            else if(data == 2) {
              this.categories = this.MenuService.getAware();
              
            }
            else if(data == 3) {
              this.categories = this.MenuService.getCDM();
            }

          }
      });*/

    });

  }





  setLang(lang) {
    
    this.translateService.use(lang);
    this.storage.set('lang', lang);
    this.sendLang(lang);

  }

  sendLang(lang) {
      this.lang.next(lang);
  }

  getLang(): Observable<any> {
    //console.log(this.langObs, 'yes')
      return this.lang.asObservable();
  }


  checkIp() {
    let result = {}
    
    const url = 'https://api.ipdata.co?api-key=28d873dd6f4e75df2d0dd65f8c0d90374d3f6fd9a884cdd9e13d5e44&amp;callback=JSONP_CALLBACK';
    return this.jsonp.request(url, { method: 'Get' })
    .map(res => res.json())
  }
  checkIpp() {

    /*return new Promise((resolve, reject) => {

      lookup(undefined, '28d873dd6f4e75df2d0dd65f8c0d90374d3f6fd9a884cdd9e13d5e44')
      .then(function(info) {
        // info.ip === 8.8.8.8
        resolve(info)
        // ...
      })

    }).catch( (e) => {
      
    });*/
  }



  initCurrency() {

    return new Promise((resolve, reject) => {
        
      
      var currency
     

          this.checkIp().subscribe((response) => {            

            if(response.country_code === 'MX' || response.country_code === 'CA' || response.country_code === 'US') currency = 'dollar';


            //if(response.continent_code === 'NA' || response.continent_code === 'CA') currency = 'dollar';
            // if(response.continent_code === 'EU') 
            else currency = 'euro';
            // country_code
            console.log('init currency', response.country_code, currency)

            this.setCurrency(currency);
            resolve(currency)
            
          })
         
          

    });
  }





  initCurrency2() {

    return new Promise((resolve, reject) => {
        
      
      var currency
      this.storage.get('currency').then((data) => {

    
        if(!data) {

          var userLang = navigator.language.split('-')[0]; // use navigator lang if available
          userLang = /(fr|en)/gi.test(userLang) ? userLang : 'ang';

          if(userLang==='en') currency = 'dollar' ; else currency = 'euro';

          this.setCurrency(currency);
          resolve(currency)

          /*this.checkIp().subscribe((response) => {

            console.log("checkIp", response )

            if(response.continent_code === 'NA' || response.continent_code === 'CA') currency = 'dollar';
            // if(response.continent_code === 'EU') 
            else currency = 'euro';
            // country_code
            console.log('init currency', response.continent_code, currency)

            this.setCurrency(currency);
            resolve(currency)
            
          })*/
         
          

        } else {
          //this.lang = data
          currency = data
          this.setCurrency(currency);
          console.log('load currency', currency)

          resolve(currency)
          
          
        }
      
      }).catch( (e) => {


        this.setCurrency('euro');
        resolve('euro')

    });


    });
  }





  

  setCurrency(currency) {
    
    //this.translateService.use(currency);
    this.storage.set('currency', currency);
    this.sendCurrency(currency);
  }

  sendCurrency(currency) {
      this.currency.next(currency);
  }

  getCurrency(): Observable<any> {
    //console.log(this.langObs, 'yes')
      return this.currency.asObservable();
  }

  getCurrency2() {
    return new Promise((resolve, reject) => {

      //return this.currency.asObservable();

      this.storage.get('currency').then((currency) => {
          resolve(currency)
      });

    });
  }

  list(ref) {
    //const filteredPosts = new BehaviorSubject<Coverage[]>(null)

    return this.af.list(ref).snapshotChanges() //preserveSnapshot


  }


  documentCoverage(slug): Observable<CoverageC> {
    //const filteredPosts = new BehaviorSubject<Coverage[]>(null)

    //if(!orderBy) orderBy = 'aware.aware'

   // this.coverageCollection = this.afs.collection<Coverage>('coverage');
  
  //this.coverageDoc = this.afs.collection<Coverage>('coverage');

  this.coverageDoc = this.afs.doc<CoverageC>('coverage/' + slug);

  //this.item = this.itemDoc.valueChanges();
    
    return this.coverageDoc.valueChanges()
    .map(c => {
      //activities = activities.reverse();  
      console.log(slug)
      if(!c) return;

      //return activities;
      const id = c.data.wp.id;
      return new CoverageC(id, c, 'fr');

      
      /*return activities.map(c => {
        //return test;
        //console.log('tt', c)
        //const data = c.payload.doc.data();
        const id = c.data.wp.id;
        return new CoverageC(id, c, 'fr');
        //return covera
      });*/
      
    });

  }

  cardDocument(id): Observable<any> {

  this.cardDocumentRef = this.afs.doc<Card>('card-add/' + id);
    
    return this.cardDocumentRef.valueChanges()
    .map(c => {
      // activities = activities.reverse();  
      // console.log(slug)
      if(!c) { return; }

      // const id = c.data.wp.id;
      return new Card(id, c);

    });

  }

  cardAdd(data) {
    // Persist a document id
    this.cardCollectionRef = this.afs.collection<Card>('card-add');

    // const id = this.afs.createId();
    // const item: Item = { id, name };
    this.cardCollectionRef.add(data);
  }



  cardCollection(type, orderBy, limit): Observable<Card> {
    // const filteredPosts = new BehaviorSubject<Coverage[]>(null)
    console.log(orderBy)

    if(!orderBy) {orderBy = 'created_at'}

    this.cardCollectionRef = this.afs.collection<Card>('card-add', ref => ref
      // .where('statut', '==', -3)
      // .where('data.wp.iscoverage', '==', true)
      .limit(limit)
      .orderBy(orderBy)
    );
    
    return this.cardCollectionRef.snapshotChanges()
    .map((activities: any) => {
      // activities = activities.reverse();  
      // return activities;

      return activities.map(a => {
        const data = a.payload.doc.data();
        const id = a.payload.doc.id;
        // console.log('tt', c)
        // const id = 1 // c.data.wp.id;
        const card = new Card(id, data);

        // console.log(card)

        // coverage.img = this.store.refFromURL(coverage.img);
        return card;
      }).reverse();
      
    });

  }


  collectionCoverages(type, orderBy, limit): Observable<CoverageC> {
    //const filteredPosts = new BehaviorSubject<Coverage[]>(null)

    if(!orderBy) orderBy = 'aware.aware'

    this.coverageCollection = this.afs.collection<CoverageC>('coverage', ref => ref
      .where('data.wp.type', '==', type)
      //.where('data.wp.iscoverage', '==', true)
      .limit(limit)
      .orderBy(orderBy)
    );
    
    return this.coverageCollection.valueChanges()
    .map((activities: any) => {
      //activities = activities.reverse();  
      //return activities;

      return activities.map(c => {
        //return test;
        //console.log('tt', c)
        //const data = c.payload.doc.data();
        const id = c.data.wp.id;
        const coverage = new CoverageC(id, c, 'fr');

        //coverage.img = this.store.refFromURL(coverage.img);
        return coverage
        //return covera
      }).reverse();
      
    });

  }
  
  

  allCoverages(): Observable<any[]> {
    //const filteredPosts = new BehaviorSubject<Coverage[]>(null)

    
    return this.af.list('/coverage/').valueChanges();
  }


  

  allCoveragesType(type, limit): Observable<any[]> {
    //const filteredPosts = new BehaviorSubject<Coverage[]>(null)

    return this.af.list('/coverage-type/' + type, ref => ref.limitToLast(limit)).valueChanges()
    .map((activities: any) => {
      activities = activities.reverse();
      return activities;
    }) as Observable<any[]>;
  }

  allCoveragesType2(type, limit, lang) {
    return new Promise((resolve, reject) => {
      let data = [];
      this.item = this.af.list('/coverage-type/' + type).snapshotChanges(); //preserveSnapshot
      this.item.subscribe(snapshots => {
        //console.log(snapshots)
        snapshots.forEach(snapshot => {
          //console.log('snapshot', snapshot)
           var coverage = new Coverage(snapshot.payload.val().id, snapshot.payload.val().data, lang)

          data.push(coverage)
        });
        //console.log(data)
        resolve(data);
      });
      
    });
  }


  coverage(id) {
    //const filteredPosts = new BehaviorSubject<Coverage[]>(null)

    
    return this.af.object('/coverage/' + id).valueChanges();
  }

  coverageSlug(slug) {
    //const filteredPosts = new BehaviorSubject<Coverage[]>(null)

    
    return this.af.object('/coverage-slug/' + slug).snapshotChanges();
  }

  coverageProvider(id, type): Observable<any[]> {
    //const filteredPosts = new BehaviorSubject<Coverage[]>(null)

    
    return this.af.list('/coverage-data/' + id + '/' + type).snapshotChanges().map(changes => {
      return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
    });
    
    //.valueChanges();
  }

  coverageProviderAll(id): Observable<any[]> {
    //const filteredPosts = new BehaviorSubject<Coverage[]>(null)

    
    return this.af.list('/coverage-data/' + id).snapshotChanges().map(changes => {
      return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
    });
    
    //.valueChanges();
  }

  






  coverage2(id) {
    return new Promise((resolve, reject) => {
      this.item = this.af.object('/coverage/' + id).snapshotChanges();//, { preserveSnapshot: true }
      this.item.subscribe(snapshot => {
        //console.log(snapshot.key)
        //console.log(snapshot.val())
        var data = snapshot.payload.val()
        resolve(data);
      });
      
    })

  }


  coverageSlugId(slug) {
    return new Promise((resolve, reject) => {
      this.item = this.af.object('/coverage-index/' + slug).snapshotChanges(); //,preserve
      this.item.subscribe(snapshot => {
        //console.log(snapshot.key)
        //console.log(snapshot.val())
        var data = snapshot.payload.val()
        resolve(data);
      });
      
    })

  }



  
  coverageFeedCollection(id, orderBy, limit): Observable<any[]> {
    //const filteredPosts = new BehaviorSubject<Coverage[]>(null)

    if(!orderBy) orderBy = 'coverageid.' + id;
    // orderBy = 'data.aware_at'

    //orderBy = 'coverageid.' + id;
    var coverageFeedCollection

    if(id==='all') coverageFeedCollection = this.afs.collection<Coverage>('feed', ref => ref
      //.where('coverageid.' + id, '>', 0)
      //.where('data.wp.iscoverage', '==', true)
      .orderBy(orderBy)
    ); else coverageFeedCollection = this.afs.collection<Coverage>('feed', ref => ref
      .where('coverageid.' + id, '>', 0)
      //.where('coverageid.' + id, '==', true)
      //.where('data.wp.iscoverage', '==', true)
      .orderBy(orderBy)
    );
    
    return coverageFeedCollection.snapshotChanges()
    .map((activities: any) => {
      //activities = activities.reverse();
      //return activities;

      return activities.map(c => {
        //return test;
        //console.log('tt', c)
        //const data = c.payload.doc.data();
        const data = c.payload.doc.data();
        const id = c.payload.doc.id;
        //const id = c.data.id;
        return new Post(id, data);
        //return covera
      }).reverse();
      
    });

  }


  coverageCardCollection(id, orderBy, limit): Observable<any[]> {
    //const filteredPosts = new BehaviorSubject<Coverage[]>(null)

    if(!orderBy) orderBy = 'coverageid.' + id;
    // orderBy = 'data.aware_at'

    //orderBy = 'coverageid.' + id;
    var coverageFeedCollection

    if(id==='all') coverageFeedCollection = this.afs.collection<Coverage>('card', ref => ref
      //.where('coverageid.' + id, '>', 0)
      //.where('data.wp.iscoverage', '==', true)
      .orderBy(orderBy)
    ); else coverageFeedCollection = this.afs.collection<Coverage>('card', ref => ref
      .where('coverageid.' + id, '>', 0)
      //.where('coverageid.' + id, '==', true)
      //.where('data.wp.iscoverage', '==', true)
      .orderBy(orderBy)
    );
    
    return coverageFeedCollection.snapshotChanges()
    .map((activities: any) => {
      //activities = activities.reverse();
      //return activities;

      return activities.map(c => {
        //return test;
        //console.log('tt', c)
        const data = c.payload.doc.data();
        //const id = c.payload.doc.id;
        //return new Post(id, data);
        return data;
      }).reverse();
      
    });

  }



  getPost(id) {
    //const filteredPosts = new BehaviorSubject<Coverage[]>(null)
    
    return this.af.object('/feed/' + id).snapshotChanges();
  }

  coveragePosts(id, type): Observable<any[]> {
    //const filteredPosts = new BehaviorSubject<Coverage[]>(null)
    //console.log('r')

    
    
    //return this.af.list('/coverage-feed/' + id + '/' + type, ref => ref.limitToLast(30)).valueChanges();
    return this.af.list('/coverage-feed/' + id + '/' + type, ref => ref.orderByChild('data/created_at').limitToLast(30)).snapshotChanges().map(changes => {
      
      //changes.reverse();
      
      return changes.map(c => {
        return new Post(c.payload.key, c.payload.val()); 
        //key: c.payload.key, ...c.payload.val() 
      }).reverse();
      //return changes;
    });
    
    
    
    
   /* list('/coverage-feed/' + id + '/' + type, {
      query: {
        limitToLast: 30,
        //orderByKey: true
        //equalTo: this.sizeSubject
      },
      //preserveSnapshot: true
    }).map((activities: any) => {
      activities = activities.reverse();
      return activities;
    }) as Observable<any[]>;
    */

  }

  coveragePostsocial(id, type): Observable<any[]> {
    //const filteredPosts = new BehaviorSubject<Coverage[]>(null)

    return this.af.list('/coverage-feed/' + id + '/social').valueChanges();
  }


  coverageWidgets(id): Observable<any[]> {
    //const filteredPosts = new BehaviorSubject<Coverage[]>(null)

    
    //return this.af.list('/coverage-widget/' + id).valueChanges()
    return this.af.list('/coverage-widget/' + id).snapshotChanges()
    
    /*.map(changes => {
      
      //changes.reverse();
      
      return changes.map(c => {
        return new Widget(c.payload.key, c.payload.val(), 'fr'); 
        //this.info = new Widget(1, this.data, this.lang)
        
        //key: c.payload.key, ...c.payload.val() 
      })//.reverse();
      //return changes;
    });*/
    
  }

  coverageSearch(id, item, search) {// : Observable<Widget[]>
    //const filteredPosts = new BehaviorSubject<Coverage[]>(null)

    
    return this.af.list('/coverage-widget/' + id, ref => ref.orderByChild(item).equalTo(search)).snapshotChanges();
  }







  

  coverageUpdate(slug, data){

    //if(!statut) statut = 'default'
    

    //console.log(slug, post)
    
    let coverageCollection = this.afs.collection<Coverage>('coverage').doc(slug)
    
    coverageCollection.ref.set(data, { merge: true });

    //if(statut!='humeur')coverageCollection.collection<any>('statut').add(data);


  }
  
  addStatutCoverage(slug, statut, post){

    if(!statut) statut = 'default'
    var data = {};
    data['statut'] = {};
    data['statut'][statut] = post;

    //data['data'] = {};
    data['statut']['last_update'] = new Date().getTime();
    //console.log(slug, post)

    
    let coverageCollection = this.afs.collection<Coverage>('coverage').doc(slug)
    
    coverageCollection.ref.set(data, { merge: true });

    if(statut!='humeur')coverageCollection.collection<any>('statut').add(data);


  }

  incrementPostInDatabase(post, aware){
    
    for(let num in post.coverage) {
      
      if(post.coverage[num].id) this.af.object('/coverage-feed/' + post.coverage[num].id + '/' + post.folder + '/'  + post.key + '/aware/aware/aware/')
      .set(aware);

    }
    
  
  }

  createPostInCollection(data, aware){

   
    const id = data.key || 'erreur' //this.afs.createId();
    //const name = data; //this.afs.createId();
    //const item: Item = { id, name };
    
    //delete data.coverage;
    this.feedCollection = this.afs.collection<Post>('feed');

    var coveragejson = {};
    //var data2 = {};
    var coverage = data.coverage || null;

    //data2.aware_at = new Date().getTime();

    if(coverage) for(let i in coverage){

      var i2 = coverage[i].id;
      if(i2) coveragejson[i2] = new Date().getTime();

    }
    
    //aware = {aware: aware, total: data.aware};
    //console.log(data[0], 'data')



    //var datafinal = {}
    //datafinal.data = data2

    
    
    //this.feedCollection.doc(id).ref.set({...data2, coverageid: coveragejson, aware, data: Object.assign({}, data)}, { merge: true });



    this.getPost(id).subscribe(c =>  {

      data = c.payload.val() // c.payload.key c.payload.key, 

      data.aware_at = new Date().getTime();
      
      this.feedCollection.doc(id).ref.set({...data, coverageid: coveragejson}, { merge: true });

    });
    


    
  }
  
  incrementPostInCollection(data, aware){
    
    const id = data.key //this.afs.createId();
    //const name = data; //this.afs.createId();
    //const item: Item = { id, name };
    this.feedCollection = this.afs.collection<Post>('feed');

    /*var coveragejson = {};
    var data2 = data.original;
    var coverage = data2.coverage || null;

    data2.aware_at = new Date().getTime();

    if(coverage) for(let i in coverage){

      var i2 = coverage[i].id;
      if(i2) coveragejson[i2] = new Date().getTime();

    }*/

    this.feedCollection.doc(id).ref.set({aware: {aware: {aware: aware}}}, { merge: true });

    //console.log('incrementPostInCollection')

    //this.feedCollection.add(item);
    
  }

  incrementLike(post){
    
    this.af.object(`feed/${post.key}/aware/aware/aware`).query.ref.transaction(likes => {
      var data = likes || false;

      if (data === false) {
        data = 1;
        this.createPostInCollection(post, data)
        this.incrementPostInDatabase(post, data)
        return data;
      } else {
        data = likes + 1;
        this.incrementPostInCollection(post, data)
        this.incrementPostInDatabase(post, data)
        return data;
      }
  
    })
     
  }

  /*incrementLikeDocument(post){
    
    var sfDocRef = this.afs.collection("cities").doc("SF");
    
    // Uncomment to initialize the doc.
    // sfDocRef.set({ population: 0 });
    
    return this.afs.firestore.runTransaction(function(transaction) {
        // This code may get re-run multiple times if there are conflicts.
        return transaction.get(sfDocRef).then(function(sfDoc) {
            var newPopulation = sfDoc.data().population + 1;
            transaction.update(sfDocRef, { population: newPopulation });
        });
    }).then(function() {
        console.log("Transaction successfully committed!");
    }).catch(function(error) {
        console.log("Transaction failed: ", error);
    });
     
  }*/







  product_like(id, data) {
    return new Promise((resolve, reject) => {

        //let user = 1 
        //console.log('like', this.like)

        if(!this.like) this.like = {}


        let index = this.like.hasOwnProperty(id);
        //let newData = JSON.stringify(data);

        if(index === true){
          // like deja
          this.product_like_remove(id);
          resolve('false');
        }
        else {

            //let product_user_ref = this.af.object('/user-product/' + user + '/' + id);
            //product_user_ref.set(data);

                    //if(!this.like) this.like = []


 //this.like = {}
            // set a key/value
            //let pdata = {}
            //pdata[id] = data
            this.like[id] = data;
            //this.like.push(data);

            //if(Array.isArray(value))//
            
            //let newData = JSON.stringify(this.like);
            let newData = this.like;

            this.storage.set('like', newData);

            this.sendBasket(newData)

            resolve('primary');

            //console.log(this.like) 
       }



        
        
      
      
    })

  }

  product_like_remove(id) {

      let index = this.like.hasOwnProperty(id);

      if(index === true){
          delete this.like[id];
          //this.save();
      }

      this.storage.set('like', this.like);

      this.sendBasket(this.like)

      //console.log(this.like)


  }
  
  product_like_check(id): any {
      //console.log(this.basket)

      /*return this.basket.filter(function(data) {
        return data.id === id;
      });*/
      if(!this.like) this.like = {}

      let index = this.like.hasOwnProperty(id);

      if(index === true){
          //this.like.splice(index, 1);
          //this.save();
          return "primary"
      }  return "false"

      //this.storage.set('like', this.like);



  }

  product_like_remove_all() {


      this.storage.remove('like');
      this.like = {}
      //this.storage.set('like', []);
      //this.storage.clear()

            //console.log(this.like)


  }
/*
  product_like_nb2: Observable<any> = 
      Observable.fromPromise(this.storage.get('like').then(projects => {
      //maybe some processing logic like JSON.parse(token)
      //return token;
        if(projects) {
          let basket_nb=Object.keys(projects).length;
          return basket_nb
        } else return 0
    }));

  product_like_nb3(): Observable<any> {
      
      Observable.fromPromise(this.storage.get('like').then(projects => {
      //maybe some processing logic like JSON.parse(token)
      //return token;
          if(projects) {
            let basket_nb=Object.keys(projects).length;
            return basket_nb
          } else return 0
      }));
      
      return this.basket.asObservable();
  }
*/
  sendBasket(data) {
      //console.log('sendBasket', data)
      this.basket.next(data);
  }

  clearBasket() {
      this.basket.next({});
  }

  getBasket(): Observable<any> {
      return this.basket.asObservable();
  }


  product_like_nb() {
    return new Promise((resolve, reject) => {


       this.storage.get('like').then((projects) => {

            if(projects) {

              //projects =  JSON.parse(projects); 
              let basket_nb=Object.keys(projects).length;
              //this.sendBasket(basket_nb)
              resolve(basket_nb)
            } else {
              //this.sendBasket(0)
              resolve(0)
            }
 
        });


      
    })

  }
  
  
  product_like_list() {
    return new Promise((resolve, reject) => {


       this.storage.get('like').then((projects) => {

            /*if(projects){
                this.like = []
                for(let project of projects){
 
                    //let savedProject = new ProjectModel(project.name, new Date(project.lastChecked), project.totalSeconds, project.active);
                    this.like.push(project);
 
                    //if(project.active){
                      //  this.startTiming(savedProject, true);
                    //}
 
                }
 
            }*/
    
            //this.storage.set('like', this.like);

            //if(projects) projects = {}

            //this.like =  JSON.parse(projects) || {}; 
            this.like =  projects || {}; 

            //console.log(this.like)

            this.sendBasket(this.like)

            resolve(this.like)
 
        });


      
    })

  }











  checkVisit() {

    return new Promise((resolve, reject) => {

      this.storage.get('e-cookie').then((data) => {
        
        if(!data) {
          
          let close = this.translateService.instant('CLOSE');
          let more_info = this.translateService.instant('MORE_INFO');
          
      
          let cookieText = this.translateService.instant('COOKIE_MSG_TEXT');
          let cookieText2 = this.translateService.instant('COOKIE_MSG_TITLE');
      
      
          //let cookieLink = "<a href='#' (click)=\"goToCoverage($event, {id: 2388, slug: 'legal', data: {}})\">Plus d'informations</a>";
          //const toastConfigCookie: ToastConfig = {timeOut: 0, closeButton: true, enableHtml: true, toastClass: 'toast-e', titleClass: 'toast-e-title', messageClass: 'toast-e-msg', positionClass: 'toast-bottom-right'};
          //this.toastrService.info(this.cookieText, this.cookieText2, toastConfigCookie);
      
          /*this.snotifyService.confirm(cookieText, cookieText2, {
            timeout: 0,
            titleMaxLength: 100,
            bodyMaxLength:1000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            buttons: [
              {text: more_info, action: (toastId, text) => {resolve('cookie') ; this.snotifyService.remove(toastId);} },
              {text: close, action: (toastId) => {this.snotifyService.remove(toastId); resolve(0)}, bold: true},
            ]
          });*/


          
          this.storage.set('e-cookie', '1');
          //resolve(0)
          
        } else {
          
          this.storage.get('e-newsletter').then((data) => {
          
            if(!data) {
              //this.goToNewsletter(true);
              resolve('newsletter')
              this.storage.set('e-newsletter', '1');
            }
      
          });

        }

      });

    })
  }

  resetStorage() {

    this.storage.remove('e-cookie');
    this.storage.remove('e-newsletter');
    //this.storage.remove('like');

  }

  removeNotif() {
    this.snotifyService.remove();
  }


  subscribeToNewsLetter(email: string, currency) {
    
    if(currency === 'euro') this.listId = 'b7063f4118'; // 995165ebb6
    else this.listId = '3a7739ec36'; //'995165ebb6';

    const url = `${this.mailChimpUrl}?u=${this.userId}&amp;id=${this.listId}&amp;subscribe=Subscribe&amp;EMAIL=${email}&amp;c=JSONP_CALLBACK`;
    console.log(url)
    return this.jsonp.request(url, { method: 'Get' })
      .map(res => res.json());
  }


  subscribeToNewsLetter2(email: string, currency) {

    //this.mymodel = null;
    return new Promise((resolve, reject) => {

      this.subscribeToNewsLetter(email, currency)
      .subscribe((res) => {
        console.log('newsletter', res)

        var msg

        if(res.result==='success') msg = this.translateService.instant('MENU_NEWSLETTER_INPUT_OK');
        else if(res.result==='error') msg = this.translateService.instant('MENU_NEWSLETTER_INPUT_ERROR');

        //const toastConfig: ToastConfig = {timeOut: 5000, closeButton: true, enableHtml: true, toastClass: 'toast-e', titleClass: 'toast-e-title', messageClass: 'toast-e-msg', positionClass: 'toast-bottom-right'};
        //this.toastrService.info(msg, null, toastConfig);
        
        this.snotifyService.success(msg, 'Newsletter', {
          timeout: 5000,
          showProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          titleMaxLength: 100,
          bodyMaxLength:1000,
        });

        //return res.result;
        resolve(res.result)
          //.pop({ result: res.result, msg: res.msg });
      });
    })
  }

  /*notifToCookie(event) {
    
    let close = this.translateService.instant('CLOSE');
    let more_info = this.translateService.instant('MORE_INFO');
    

    let cookieText = this.translateService.instant('COOKIE_MSG_TEXT');
    let cookieText2 = this.translateService.instant('COOKIE_MSG_TITLE');


    let cookieLink = "<a href='#' (click)=\"goToCoverage($event, {id: 2388, slug: 'legal', data: {}})\">Plus d'informations</a>";
    //const toastConfigCookie: ToastConfig = {timeOut: 0, closeButton: true, enableHtml: true, toastClass: 'toast-e', titleClass: 'toast-e-title', messageClass: 'toast-e-msg', positionClass: 'toast-bottom-right'};
    //this.toastrService.info(this.cookieText, this.cookieText2, toastConfigCookie);

    this.snotifyService.confirm(cookieText, cookieText2, {
      timeout: 0,
      titleMaxLength: 100,
      bodyMaxLength:1000,
      showProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      buttons: [
        {text: close, action: (toastId) => {this.snotifyService.remove(toastId); }, bold: true},
      ]
    });

  }*/

  

  
  /*
  coverageData(id, type): Subject<Data[]> {
    const postsObservable = new BehaviorSubject<Data[]>(null)

   

    return postsObservable
  }

  allCoverages() {
    return new Promise((resolve, reject) => {
      this.rootRef.child('coverage').once('value', snapshot => {
        const data = snapshot.val()
        const coverages = Object.keys(data).map(id => new Coverage(id, data[id]))
        resolve(coverages)
      })
    })
  }*/









  coverage_search(search): Observable<any[]> {
    
    this.items = this.af.list('/coverage/').valueChanges()
    .map((items: any) => {
      //const filtered = items.filter(item => item.data.wp.title === search);
      return items;
    }) as Observable<any[]>;

    return this.items;
  }



  createNewTopic(post, options, coverageStatut, setstatut, topic, photo, tag, sethumeur, setforme) {
    return new Promise((resolve, reject) => {
      //const {user, content} = options
      let id = post.key  // pas si  mocheeeeeee
      const data2 = post
      //const coverageStatut = coverageStatut
      //const topic = topic
      const statut = setstatut
      const humeur = sethumeur
      const forme = setforme
      
                  console.log(post)

      delete post.$key 
      delete post.$exists
      
      if(!tag) tag = null;

      


      //var order = 1000000000000-date;
      var content = {description: options, title: options, text: options}
      
      
      const data = {
        //coverage: 'cove',
        type: 'statut',
        //humeur: humeur,
        statut: statut,
        created_at: new Date().getTime(),
        //type: topic,
        content: content,
        post: post.original,
        tag: tag,
        date: new Date().getTime(),
        //order: order
      }

      //console.log(data)
      this.createPostInCollection(post, 1)
      
    


      
      if(photo) data2['photo'] = true
      //console.log(data2)
      if(statut) {
        data2['statut'] = statut
         if(!statut.type) statut.type = 'default';
         if(!statut.cat) statut.cat = 'default';
      }


        //let coverage_ref_128 = this.af.object('/coverage-feed/' + 128 + '/aware/' + id);
        //coverage_ref_128.set(data2);

      var num

      var coverage = post.coverage;
      for (num in coverage){
        
        
        //let coverage_ref = this.af.object('/coverage-feed/' + coverage[num].id + '/aware/' + id);

        //console.log(statut)
        //if(coverage[num].type != 'tag') coverage_ref.set(data2);
                
      
      }
    
    
    
    coverage = coverageStatut;
    if(statut)
      {
        
        
              for (num in coverage){
                
              
                
                if(coverage[num].type != 'tag')  
                {
                
                  if(humeur) {

                    this.addStatutCoverage(coverage[num].slug, 'emo', humeur)
                
                
                    //let coverage_ref_humeur = this.af.object('/coverage-type/' + coverage[num].type + '/' + coverage[num].id + '/statut/humeur/');
                    //coverage_ref_humeur.set(humeur);

                    //let coverage_ref_humeur2 = this.af.object('/coverage/' + coverage[num].id + '/statut/humeur/');
                    //coverage_ref_humeur2.set(humeur);
                    
                  }

                  if(forme) {
                    
                    this.addStatutCoverage(coverage[num].slug, 'forme', forme)
                    
                  }

                  this.addStatutCoverage(coverage[num].slug, statut.type, data)
                

                  //let coverage_ref_statut_type = this.af.object('/coverage-type/' + coverage[num].type + '/' + coverage[num].id + '/statut/' + statut.type);
                  //coverage_ref_statut_type.set(data);

                  //let coverage_ref_statut_type2 = this.af.object('/coverage/' + coverage[num].id + '/statut/' + statut.type);
                  //coverage_ref_statut_type2.set(data);


                 
                 
                 
                  //let coverage_ref_last_update = this.af.object('/coverage-type/' + coverage[num].type + '/' + coverage[num].id + '/last_update/');
                  //coverage_ref_last_update.set(date);

                  //let coverage_ref_last_update2 = this.af.object('/coverage/' + coverage[num].id + '/last_update/');
                  //coverage_ref_last_update2.set(date);

                  
                        //var order = 1000000000000-date;
                    
                
                //let coverage_ref_add_feed = this.af.list('/coverage-feed/' + coverage[num].id + '/statut/');
                //coverage_ref_add_feed.push(data);
                
              /*  // add topic
                const postRef = this.rootRef
                .child('coverage-feed')
                .child(coverage[num].id)
                //.child(datenow)
                .child('statut').push()
                
                postRef.set(data, error => {
                  if (error) {
                    reject()
                  } else {
                    resolve()
                  }
                })
                */
                resolve()
              
              }
            }
    
    } else resolve();
      
      
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/coverage.service.ts